import { RefObject } from "react";

import { EditArticleText } from "@EditArticleContainer/shared/types/editArticle.types";

import { createContentFromHTML } from "./getValueFromRefMap";

export type RefMap = Map<string, RefObject<HTMLElement>>;
type EditableField = { value: EditArticleText[] };

/**
 * 편집 가능한 leaf 필드의 value만 ref(DOM)에서 읽어 덮어쓴다.
 * ref가 렌더되지 않았거나 필드가 없으면 기존 값을 유지하여 비편집 데이터 유실을 방지한다.
 */
export const overwriteFromRef = (
  refMap: RefMap,
  field: EditableField | undefined,
  refCode: string,
) => {
  if (!field) return;
  if (!refMap.get(refCode)?.current) return;
  field.value = createContentFromHTML(refMap, refCode).value;
};

export const cloneContent = <T>(data: T): T =>
  JSON.parse(JSON.stringify(data)) as T;

export const isEmptyContent = (data: unknown) =>
  !data || Object.keys(data as object).length === 0;
